import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutTelemarketingCallHistoryReport } from "./autogen/AutogenLayoutTelemarketingCallHistoryReport";

export class TelemarketingCallHistoryReport extends AutogenLayoutTelemarketingCallHistoryReport {
    private _assignedUser = "Assigned CSRs";
    private _operationUser = "Operations Users";
    private _pageBreakAssignedUsrCaption = "Page Break After Each Assigned CSR";
    private _pageBreakOpsUsrCaption = "Page Break After Each Operations User"

    onLoad() {
        this.excludabletextboxUsers.textbox.caption = this._assignedUser;
    }

    switchSourceOnChange(){
        const isChecked = this.switchSource.checked;
        this.excludabletextboxUsers.textbox.caption = isChecked ? this._assignedUser : this._operationUser;
        this.checkboxPageBreak.caption = isChecked ? this._pageBreakAssignedUsrCaption : this._pageBreakOpsUsrCaption;
        this.switchSort.leftCaption = isChecked ? "Shipper Name" : "Customer Name";
    }

    textboxAssignUsersBeforeLookupMode(event: LookupModelSearchEvent) {
        event.filter.web_user_type = "U || E"
    }

}
